import Smartphones from 'Reports/views/TaxPaymentReport/TaxPaymentReportsView/containers/Smartphones'
import Tablets from 'Reports/views/TaxPaymentReport/TaxPaymentReportsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TaxPaymentReportsView = getCurrentDeviceView(Smartphones, Tablets)

export default TaxPaymentReportsView
